import React from 'react';
import {createRoot} from 'react-dom/client';
import styles from './styles.module.css';

const pdfs = [
    {
        name: 'Summary of Recommendations',
        link: '/about/summary-of-recommendations.html',
        newTab: true,
        image: '/images/hero-banners/STILLSCSA460.webp',
    },
    {
        name: 'Guidelines',
        link: 'https://research-repository.uwa.edu.au/en/publications/deprescribing-in-older-people-a-clinical-practice-guideline',
        newTab: true,
        image: '/images/hero-banners/STILLSv50.webp',
    },
    {
        name: 'Administrative Report',
        link: 'https://dl.dropboxusercontent.com/scl/fi/8lcwzj0qwdefpydfvfdvk/Administrative-report.pdf?rlkey=s7biwdc19904tzl9g08okngh8&st=wwg69bkz&dl=1',
        image: '/images/hero-banners/STILLSv201.webp',
    },
    {
        name: 'Technical Report',
        link: 'https://dl.dropboxusercontent.com/scl/fi/qundtx16mcyq303nwjyh1/Technical-Report.pdf?rlkey=pfcriyoda2vldn9okvcgjggrr&st=cawoz2lt&dl=1',
        image: '/images/hero-banners/STILLSCSA290.webp',
    },
    {
        name: 'Public Consultation Report',
        link: 'https://dl.dropboxusercontent.com/scl/fi/85mh9sv4oelhatazyy26l/Public-Consultation-Report.pdf?rlkey=k27e77zsgzmx11j95jyj964m7&st=2edief90&dl=1',
        image: '/images/hero-banners/STILLSCSA335.webp',
    },
    {
        name: 'Dissemination and Implementation Plan',
        link: 'https://dl.dropboxusercontent.com/scl/fi/wq2wd9ifsg7ykm9312vj5/Dissemination-and-Implementation-Plan.pdf?rlkey=pea9bk8i9itgcs0dvssbzhjb4&st=snlgvaz4&dl=1',
        image: '/images/hero-banners/STILLSCSA665.webp',
    },
];

const drugClasses = [
    {
        name: 'Consumer Preface',
        link: '/01-consumer-preface.html',
    },
    {
        name: 'Plain Language Summary',
        link: '/02-plain-language-summary.html',
    },
    {
        name: 'Executive Summary',
        link: '/03-executive-summary.html',
    },
    // {
    //     name: 'Introduction',
    //     link: '/06-introduction.html',
    // },
    {
        name: 'Polypharmacy / Multiple Drug Classes',
        link: '/07-poly-pharmacy-mutiple-drug-classes.html',
    },
    {
        name: 'Drug Index',
        link: '/about/individual-drug-classes.html',
    },
    {
        name: 'Glossary',
        link: '/05-glossary.html',
    },
    {
        name: 'Abbreviations',
        link: '/04-abbreviations.html',
    },
    {
        name: 'References',
        link: '/about/references.html',
    },
];

const HomepageMid = () => {
    const [showAdaStatement, setShowAdaStatement] = React.useState(false);

    return (
        <div className={styles.container}>
            <h2>PDFs to Download</h2>
            <div className={`${styles.inner} ${styles.innerPdf}`}>
                {pdfs.map(o => (
                    <a
                        key={o.name}
                        href={o.link}
                        {...(o.newTab
                            ? {target: '_blank', rel: 'noreferrer'}
                            : {})}
                        style={{
                            background: `url('${o.image}')`,
                            backgroundSize: 'cover',
                        }}
                    >
                        <svg
                            width="24px"
                            height="24px"
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                        >
                            <g fill="#fff">
                                <path d="M9 .75A.75.75 0 019.75 0h4.5c.206 0 .393.083.529.218l.001.002.002.001A.748.748 0 0115 .75v4.5a.75.75 0 01-1.5 0V2.56L7.28 8.78a.75.75 0 01-1.06-1.06l6.22-6.22H9.75A.75.75 0 019 .75z" />
                                <path d="M3.25 3.5a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h7.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0110.75 14h-7.5A2.25 2.25 0 011 11.75v-7.5A2.25 2.25 0 013.25 2h4a.75.75 0 010 1.5h-4z" />
                            </g>
                        </svg>
                        {o.name}
                    </a>
                ))}
            </div>
            <h2>Community Service Announcement</h2>
            <video
                controls poster="/images/hero-banners/STILLSCSA183.webp"
                style={{
                    width: '100%',
                    maxWidth: '800px',
                    height: 'auto',
                }}
            >
                <source src="https://www.dropbox.com/scl/fi/8u59rw9k7othgb9zutw8n/CSAUWA30.mp4?rlkey=g55go6uge8h3xiyzc4tuk2my9&raw=1" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <h2>Digital Guidelines</h2>
            <div className={styles.inner}>
                {drugClasses.map(o => (
                    <a key={o.name} href={o.link}>
                        {o.name}
                    </a>
                ))}
            </div>
            <h2>Endorsed By</h2>
            <div className={styles.upperEndorsed}>
                <img src="/images/officially-endorsed/RACGP.webp" alt="racgp" />
                <img
                    src="/images/officially-endorsed/ANZSGM.webp"
                    alt="ANZSGM"
                />
            </div>
            <div className={styles.endorsed}>
                <img src="/images/officially-endorsed/ACP.webp" alt="acp" />
                <img src="/images/officially-endorsed/AdPha.webp" alt="adpha" />
                <img src="/images/officially-endorsed/PSA.webp" alt="psa" />
            </div>
            <div className={styles.endorsed}>
                <img
                    src="/images/officially-endorsed/Optometry-Australia.webp"
                    alt="optometry-aus"
                />
                <img src="/images/officially-endorsed/ADEA.webp" alt="adea" />
                <img src="/images/officially-endorsed/ADA.webp" alt="ada" />
                <span className={styles.endorsedAsterisk}>*</span>
                <img src="/images/officially-endorsed/APodA.webp" alt="apoda" />
            </div>
            <p
                onClick={() => {
                    if (!showAdaStatement) {
                        setShowAdaStatement(true);
                    }
                }}
            >
                <b
                    style={{
                        cursor: 'pointer',
                        color: 'blue',
                        textDecoration: 'underline',
                    }}
                >
                    {'*ADA endorsement statement '}
                </b>
                {showAdaStatement &&
                    'The Australian Dental Association endorses these guidelines, acknowledging deprescribing as part of prescribing practice within the scope of dentistry, and upholding the role of dentists to identify potential medicine-related oral health issues and facilitate interdisciplinary discussions.'}
            </p>
        </div>
    );
};

export default () => {
    const domNode = document.getElementById('homepage-mid');
    if (domNode) {
        const root = createRoot(domNode);
        root.render(<HomepageMid />);
    }
};
